// src/stages/stage1Plant/environment/PlantBackground360.jsx
import { Environment } from "@react-three/drei";

export default function PlantBackground360({
  hdr,
  environmentIntensity = 1,
  backgroundIntensity = 1,
}) {
  return (
    <Environment
      files={hdr}
      background
      environmentIntensity={environmentIntensity}
      backgroundIntensity={backgroundIntensity}
    />
  );
}